module.exports = "./images/04_big_shopvise.jpg";